import React from 'react';
import { SlideContainer } from '../SlideContainer';
import { FadeInStagger, FadeIn } from '../FadeIn';
export const Slide07Why = () => {
  const props = [{
    title: 'Engaging and Fluid',
    desc: 'Conversational, can be done anytime, anywhere, on any device'
  }, {
    title: 'Multilingual',
    desc: 'Supports multiple languages for diverse cohorts'
  }, {
    title: 'Grounded in Your Content',
    desc: 'Built on your cases, your frameworks, your rubrics, not generic templates'
  }, {
    title: 'Consistent',
    desc: 'Every student gets the same rigor, same quality'
  }, {
    title: 'Improves Over Time',
    desc: 'Evaluation quality sharpens with usage and feedback'
  }, {
    title: 'We Own the Pipeline',
    desc: 'We create exercises, maintain them, handle updates as your material evolves'
  }];
  return <SlideContainer data-id="element-187">
      <FadeInStagger data-id="element-188">
        <FadeIn data-id="element-189">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-16" data-id="element-190">
            Measure comprehension, not completion
          </h2>
        </FadeIn>

        <div className="space-y-6 max-w-4xl" data-id="element-191">
          {props.map((prop, i) => <FadeIn key={i} data-id="element-192">
              <div className="flex flex-col md:flex-row md:items-baseline border-b border-white/5 pb-6" data-id="element-193">
                <h3 className="text-lg font-medium text-white md:w-1/3 shrink-0 mb-2 md:mb-0" data-id="element-194">
                  {prop.title}
                </h3>
                <p className="text-white/60 md:w-2/3 leading-relaxed" data-id="element-195">
                  {prop.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </FadeInStagger>
    </SlideContainer>;
};